import { Location } from '@angular/common';
import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output,
} from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatTooltip } from '@angular/material/tooltip';
import { DataTableContainerComponent } from '../../../../components/data-table-container/data-table-container.component';
import { SecondsToDurationPipe } from '../../../../pipes/seconds-to-duration.pipe';
import {
  SignalingInteractionBlock,
  SignalingInteractionBlockData,
} from '../../client-signaling.model';

@Component({
  selector: 'app-signaling-block-interaction-table',
  imports: [
    MatIcon,
    MatIconButton,
    MatTableModule,
    MatTooltip,
    DataTableContainerComponent,
    SecondsToDurationPipe,
  ],
  templateUrl: './signaling-block-interaction-table.component.html',
  styleUrl: './signaling-block-interaction-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignalingBlockInteractionTableComponent {
  private readonly _location = inject(Location);

  dataSource = input<SignalingInteractionBlock['data']>([]);

  hideActions = input(false, { transform: booleanAttribute });

  hideFlowButton = input(false, { transform: booleanAttribute });

  itemRemove = output<string>();

  displayedColumns = ['name', 'version', 'duration', 'actions'];

  protected openFlowView(element: SignalingInteractionBlockData): void {
    window.open(
      this._location.prepareExternalUrl(`interactions/${element.interactionId}/flow`),
      '_blank'
    );
  }
}
